import { useEffect } from 'react'
import Select from 'react-select'
import { PageHeader } from '../../../../common/index'
import { useNavigationContext } from '../../../../context/NavigationContext'
import { useDashboardAssociationContext } from '../../../../context/DashboardAssociationContext'
import WebshopStats from './WebshopStats'
import { Booklet } from 'types/generated.types'

const DashboardResellers = () => {
  const { associationData, associationId, defaultBooklet, associationBooklets, selectedBooklet, setSelectedBooklet } = useDashboardAssociationContext()
  const { setNavigationActivated } = useNavigationContext()

  useEffect(() => {
    setNavigationActivated(true)
  }, [setNavigationActivated])

  const isMainAssociation = defaultBooklet?.mainAssociationId === associationId;

  // Create options for react-select
  const bookletOptions = associationBooklets
    .filter((booklet: Booklet) => booklet.validFrom)
    .sort((a, b) => new Date(b.validFrom!).getTime() - new Date(a.validFrom!).getTime())
    .map((booklet: Booklet) => ({
      value: booklet,
      label: booklet.title
    }));

  return (
    <div id="dashboard" className="resellers">
      <PageHeader>
        <h1>Återförsäljare</h1>
        <p>Här ser du alla era återförsäljare</p>
      </PageHeader>

      <div className="container flex flex-col items-center">
        {selectedBooklet && (
          <>
            <div className="resellers-webshop-stats">
              <div className="md flex flex-col gap-1">
                {bookletOptions.length > 1 && (
                  <>
                    <label htmlFor="booklet-select" className="select-label">Välj häfte:</label>
                    <Select
                      value={bookletOptions.find(option => option.value === selectedBooklet)}
                      onChange={(option) => setSelectedBooklet(option ? option.value : undefined)}
                      options={bookletOptions}
                      placeholder="Välj häfte"
                      isSearchable={false}
                      classNamePrefix="select"
                    />
                  </>
                )}
                <WebshopStats
                  associationId={associationId}
                  selectedBooklet={selectedBooklet}
                  mainAssociationName={isMainAssociation ? associationData?.name : undefined}
                />
              </div>
            </div>
          </>
        )}
        <div style={{ maxWidth: '525px' }}>
          <p className="modal-description flex flex-col gap-1">
            <span><b>ÅF:s (återförsäljaren) förtjänst </b>visar vad de tjänar på sin egen försäljning samt ev. stöd från huvudföreningens försäljning.</span>
            <span><b>Er förtjänst</b> visar hur mycket ni tjänar på respektive återförsäljares webbshopsförsäljning.</span>
            <span>Alla belopp anges inkl. moms.</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default DashboardResellers
